import type { IPlainObject } from "app/pages/sales-intelligence/types/plainObject";

import { PendingFilterTitleSpinner } from "../../components/filters/PendingFilter/PendingFilterTitleSpinner";
import { PendingFilterView } from "../../components/filters/PendingFilter/PendingFilterView";
import { PendingFilterModel } from "../../models/PendingFilterModel";
import type { FilterDefinition, FilterPendingParts } from "../../types/filterDefinition";
import type { SearchFilterInstance } from "../../types/searchFilterInstance";

/**
 * Placeholder instance for a definition whose required data is still fetching. The framework supplies the
 * model/views (a definition never names a view for its pending state); identity mirrors the real instance
 * that replaces it, so slot position and expansion carry over on the swap.
 */
export const createPendingInstance = <
    TValues extends IPlainObject,
    TApiCategory extends string,
    TCtx,
    TDataSource extends string,
    TCapability extends string,
>(
    definition: FilterDefinition<TValues, TApiCategory, TCtx, TDataSource, TCapability>,
    parts: FilterPendingParts,
): SearchFilterInstance<TValues, TApiCategory> => {
    const { bodyText, ...chrome } = parts;

    // Same cast wrinkle as `defineFilter`: `SearchFilterInstance<TValues, …>` is a conditional over an
    // abstract `TValues` the compiler cannot verify structurally.
    return {
        key: definition.key,
        apiCategory: definition.apiCategory,
        category: definition.category,
        trackingName: definition.trackingName,
        title: definition.titleKey,
        ...chrome,
        icon: PendingFilterTitleSpinner,
        filterView: PendingFilterView,
        filter: new PendingFilterModel({ bodyText }),
    } as unknown as SearchFilterInstance<TValues, TApiCategory>;
};
